import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {Router} from '@angular/router';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {HomeOffice} from '@model/HomeOffice';
import {HierarchyA} from '@model/HierarchyA';
import {HierarchyC} from '@model/HierarchyC';
import {HierarchyB} from '@model/HierarchyB';
import {TreeItem} from '@progress/kendo-angular-treeview';
import {HierarchyTree} from '@model/HierarchyTree';
import {HierarchyType} from '@model/HierarchyType';
import {HierarchyParent} from '@model/HierarchyParent';
import {HierarchyNumber} from '@model/HierarchyNumber';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';


@Component({
  selector: 'app-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.scss']
})
export class HierarchyComponent implements OnChanges, OnInit {


  @Input() selectedHomeOffice: HomeOffice;
  @Input() hierarchyListA: HierarchyA[] = [];
  @Input() hierarchyListB: HierarchyB[];
  @Input() hierarchyListC: HierarchyC[];
  @Input() topHierarchyData: HierarchyTree[];
  @Input() bottomHierarchyData: HierarchyTree[];
  @Input() storeCount: any;
  @Input() chain: any;
  @Input() selectedStoreLevel: any;
  @Input() selectedStoreLevelParent: any;
  @Input() oldKey: any;
  @Output() addHierarchyLevel = new EventEmitter<any>();
  @Output() updateHierarchyLevel = new EventEmitter<any>();
  @Output() deleteHierarchyLevel = new EventEmitter<any>();
  @Output() addHierarchyStore = new EventEmitter<any>();
  @Output() updateHierarchyStore = new EventEmitter<any>();
  @Output() deleteHierarchyStore = new EventEmitter<any>();
  @Output() typeValueChange1 = new EventEmitter<any>();

  levels = Array.from(Array(100).keys());
  selectedLevel: number = 0;
  newTypeTextValue: any;

  selectedType: HierarchyType;
  selectedParent: HierarchyParent;
  selectedNumber: HierarchyNumber;
  selectedStoreId: string;
  selectedChain: string;
  selectedName: string;
  selectedDescription: string;
  hierarchyTypeArray: HierarchyType[] = [];
  hierarchyParentArray: HierarchyParent[] = [];
  hierarchyNumberArray: HierarchyNumber[] = [];

  public selectedTopHierarchy: any[] = [''];
  public selectedBottomHierarchy: any[] = [''];
  public levelButtonBoolean: boolean = true;
  public levelValue: any;

  constructor(public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public router: Router,
              public localStorage: LocalStorageIndexedService,
              private cdr: ChangeDetectorRef) {
  }


  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.hierarchyListA != undefined && this.hierarchyListB != undefined && this.hierarchyListC != undefined) {
      this.buildTypeArray(true);
      this.buildNumberArray();
      this.buildParentArrayFromType(true);
    }
    this.cdr.markForCheck();
  }

  buildTypeArray(refresh: boolean): void {

    if (this.hierarchyTypeArray.length === 0) {
      console.log('this should be happening if ===0 ...');
      let count = 0;
      this.hierarchyListA.forEach(item => {
        this.hierarchyTypeArray.push({type: item.type, level: item.level, value: count});
        count++;
      });
      this.selectedType = this.hierarchyTypeArray[0];
    } else if (refresh) {
      let count = 0;
      this.hierarchyTypeArray = [];
      this.hierarchyListA.forEach(item => {
        this.hierarchyTypeArray.push({type: item.type, level: item.level, value: count});
        count++;
      });
      this.selectedType = this.hierarchyTypeArray[0];
    }
  }

  buildNumberArray(): void {
    let count = 0;
    if (this.hierarchyNumberArray.length === 0) {
      this.hierarchyListB.forEach(item => {
        this.hierarchyNumberArray.push({
          chain: item.chain,
          storeConcatLvl: item.storeConcatLvl,
          value: count,
          storeId: item.storeId
        });
        count++;
      });
    }
  }

  hierarchyTypeDDChange(value): void {
    this.selectedType = value;
    this.hierarchyParentArray = [];
    let count = 0;
    this.hierarchyListC.filter(item => {
      if (item.level > this.selectedType.level) {
        this.hierarchyParentArray.push({
          chain: item.chain,
          key: item.key,
          level: item.level,
          levelParent: item.levelParent,
          levelUpdated: item.levelUpdated,
          storeId: item.storeId,
          value: count
        });
        count++;
        return;
      }
    });

    this.hierarchyParentArray = this.hierarchyParentArray
      .filter((value, index, self) => self.map(x => x.key).indexOf(value.key) == index);
    this.selectedParent = this.hierarchyParentArray.find(pItem => pItem.key === value.levelParent);
  }


  buildParentArrayFromType(refresh: boolean): void {
    this.hierarchyParentArray = [];
    let count = 0;
    this.hierarchyListC.filter(item => {
      if (item.level > this.selectedType.level) {
        this.hierarchyParentArray.push({
          chain: item.chain,
          key: item.key,
          level: item.level,
          levelParent: item.levelParent,
          levelUpdated: item.levelUpdated,
          storeId: item.storeId,
          value: count
        });
        count++;
      } else {
        if (item.level === this.selectedType.level) {
          this.hierarchyParentArray.push({
            chain: item.chain,
            key: item.levelParent,
            level: item.level,
            levelParent: item.levelParent,
            levelUpdated: item.levelUpdated,
            storeId: item.storeId,
            value: count
          });
          count++;
        }

      }
    });
    this.hierarchyParentArray = this.hierarchyParentArray
      .filter((value, index, self) => self.map(x => x.key).indexOf(value.key) == index);

    this.selectedParent = this.hierarchyParentArray[0];
  }


  buildParentArray(selectedNode: HierarchyC): void {
    this.hierarchyParentArray = [];
    let count = 0;
    this.hierarchyListC.forEach(item => {
      if (selectedNode.level < item.level) {
        this.hierarchyParentArray.push({
          chain: item.chain,
          key: item.key,
          level: item.level,
          levelParent: item.levelParent,
          levelUpdated: item.levelUpdated,
          storeId: item.storeId,
          value: count
        });
        count++;
      } else if (selectedNode.level === item.level) {
        this.hierarchyParentArray.push({
          chain: item.chain,
          key: item.levelParent,
          level: item.level,
          levelParent: item.levelParent,
          levelUpdated: item.levelUpdated,
          storeId: item.storeId,
          value: count
        });
        count++;
      }
    });
    this.hierarchyParentArray = this.hierarchyParentArray
      .filter((value, index, self) => self.map(x => x.key).indexOf(value.key) == index);

    this.selectedParent = this.hierarchyParentArray.find(pItem => pItem.key === selectedNode.levelParent);
  }

  public async levelValueChange(level: any) {
    this.levelValue = level;
    if (level === 0 || level === 99) {
      this.levelButtonBoolean = true;
    } else {
      this.levelButtonBoolean = false;
    }
  }

  typeTextBoxChange(type: any) {
    console.log('type:' + type);
  }

  storeValueChange(store: string) {
    console.log('selectedStore:' + store);
  }


  selectionChangeTopHierarchy(selectedTopHierarchy: TreeItem) {
    this.selectedLevel = this.hierarchyListA.find(x => x.type === selectedTopHierarchy.dataItem.type).level;
    if (this.selectedLevel === 0 || this.selectedLevel === 99) {
      this.levelButtonBoolean = true;
    } else {
      this.levelButtonBoolean = false;
    }
    this.newTypeTextValue = this.hierarchyListA.find(x => x.type === selectedTopHierarchy.dataItem.type).type;
  }

  selectedBottomHierarchyNode(selectedBottomHierarchy: TreeItem): void {
    this.hierarchyListC.filter(item => {
      if (selectedBottomHierarchy.dataItem.type.includes(item.key)) {
        this.buildNumberArray();
        this.buildTypeArray(false);
        this.buildParentArray(item);
        this.selectedName = item.key;
        this.selectedDescription = item.description;
        this.selectedType = this.hierarchyTypeArray.find(type => item.type === type.type);
        this.selectedNumber = this.hierarchyNumberArray.find(nItem => nItem.storeId === item.storeId);
        this.selectedStoreId = item.storeId;
        this.selectedChain = item.chain;
      }
    });
  }

  getResults(values): void {
    console.log('results for API: ', values);
    // if(values.)
    if (values.name != null && values.parent != null && values.type != null) {
      if (values.add) {
        this.addHierarchyStore.emit(values);
      } else if (values.delete) {
        this.deleteHierarchyStore.emit(values);
      } else if (values.update) {
        this.updateHierarchyStore.emit(values);
      }
    } else {
      console.error('invalid form');
      this.dialogService.showErrorNotification('Invalid selection, please try again');
    }
  }

  focus(ddl): void {
    if (ddl !== undefined) {
      ddl.focus();
    }
  }

  addLevel() {
    let results = {
      selectedLevel: this.selectedLevel,
      levelUpdated: false,
      newTypeTextValue: this.newTypeTextValue
    };
    this.addHierarchyLevel.emit(results);
    this.buildTypeArray(true);
    this.buildParentArrayFromType(true);
    this.clearLevel();
  }

  deleteLevel() {
    let results = {
      selectedLevel: this.selectedLevel,
      levelUpdated: false,
      newTypeTextValue: this.newTypeTextValue
    };
    this.deleteHierarchyLevel.emit(results);
    this.buildTypeArray(true);
    this.buildParentArrayFromType(true);
    this.clearLevel();
  }

  async updateLevel() {
    let results = {
      selectedLevel: this.selectedLevel,
      levelUpdated: false,
      newTypeTextValue: this.newTypeTextValue
    };
    await this.updateHierarchyLevel.emit(results);
    await this.buildTypeArray(true);
    await this.buildParentArrayFromType(true);
    this.clearLevel();
  }

  clearLevel() {
    this.selectedLevel = 0;
    this.newTypeTextValue = '';
  }

}
